export default "__VITE_ASSET__B1p2YLsT__"